/**
 * NF-961: Controller for managing notifications if type is VehicleNotChargingNormally
 */

/**
 * @class VehicleNotChargingNormallyController
 * Initializes a new instance of the VehicleNotChargingNormallyController.
 */
function VehicleNotChargingNormallyController() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
VehicleNotChargingNormallyController.$inject = ['$rootScope', '$state', '$timeout', 'NotificationService', '$message', '$Loading'];


VehicleNotChargingNormallyController.prototype = {

    /**
     * @type {NotificationModel} notification
     */
    notification: {},
    /**
     * Initializes the controller with necessary services and scope.
     * @param {Object} $rootScope - AngularJS $rootScope object
     * @param {ui.IStateService} $state - State service for navigation
     * @param {ui.IStateService} $timeout - Timeout service for asynchronous operations
     * @param {NotificationService} NotificationService
     * @param {$message} $message
     * @param {$Loading} $Loading
     */
    init: function ($rootScope, $state, $timeout, NotificationService, $message, $Loading) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.notificationService = NotificationService;
        this.$message = $message;
        this.$Loading = $Loading;


        // Map notification to NotificationModel
        this.notification = this.notificationService.mapNotification(this.notification);
    },


    /**
     * Make a new charge request
     * @returns {angular.IPromise<*>}
     */
    makeANewChargeRequest: function () {
        // Once the charging point is marked as free, mark the notification as read
        this.notificationService.markAsRead(this.notification.Id)
            .then(() => {
                this.close();

                if (this.$state.current.name === 'internal.home') {
                    this.$rootScope.$broadcast('make-a-new-charge-request');
                } else {
                    this.$state.go('internal.home').finally(() => {
                        setTimeout(() => {
                            this.$rootScope.$broadcast('make-a-new-charge-request');
                        }, 100)
                    });
                }
            }, this.$message.error) // Handle error for marking notification as read
            .finally(this.$Loading.blockUI());
    },

    /**
     * Don't make a new charge request
     */
    dontMakeANewChargeRequest: function () {
        this.notificationService.markAsRead(this.notification.Id)
            .then(() => {
                this.close();
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    }
};


// Register the ChargeHasEndedController controller with the AngularJS module
angular.module('internal.notifications').controller('VehicleNotChargingNormallyController', VehicleNotChargingNormallyController);